export { useGetNotices, UseGetNoticesResult } from './useGetNotices';
